<template>
  <el-dialog
    title="备注"
    :visible.sync="state"
    width="60%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <!-- <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form> -->
    <el-form :model="formData" :rules="rules" ref="formData">
      <el-form-item prop="remark">
        <el-input v-model="formData.remark" type="textarea"></el-input>
      </el-form-item>

      <div class="button-group" style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 185px; margin: 0 20px"
          class="form-button"
          @click="submitFn"
        >
          <span>保存</span>
        </el-button>
      </div>
    </el-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    row: Object,
    roles: Array
  },
  watch: {
    // row(newData) {
    //   console.log("watch", newData);
    // },
    row: {
      handler(newData) {
        console.log(newData)
        if (!newData) return
        let that = this
        // console.log("watch", newData);
        that.formData = newData
        // that.$nextTick(() => {
        // that.$refs.editor.html = newData.content
        // })
      },
      immediate: true
    }
  },
  data() {
    return {
      fileList: [],
      formData: {
        // title: '',
        // content: '',
        // status: 1,
        // thumbnail: ''
      },
      // 表单配置
      formConfig: [
        {
          label: '讲解人',
          field: 'explainer',
          type: 'text'
          // rules: [{ required: true, message: '类型必填', trigger: 'blur' }]
        },
        {
          label: '备注',
          field: 'remark',
          type: 'text'
        }
      ],
      rules: {
        remark: [{ required: true, message: '备注必填', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    submitFn() {
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          this.$emit('confirm', this.formData)
        }
      })
      console.log('更新数据处理', this.formData)
    }
  },
  mounted() {
    // this.$nextTick(() => {
    // this.$refs.editor.html = this.formData.content
    // })
  }
}
</script>

<style></style>
